import React from "react";
import { Link } from "react-router-dom";
import { XCircle, Home, ArrowRight } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";
import { LOGO_URL } from "../data/site";

export default function DonateCancel() {
  const { t } = useLanguage();
  return (
    <div className="min-h-[70vh] flex items-center" data-testid="donate-cancel-page">
      <div className="gk-container py-20">
        <div className="max-w-xl mx-auto bg-white rounded-[2rem] border border-black/5 shadow-xl p-10 text-center">
          <img src={LOGO_URL} alt="GKNL" className="h-24 w-24 mx-auto rounded-full bg-white border border-black/5 p-2" />
          <XCircle className="h-16 w-16 text-[#B5651D] mx-auto mt-6" />
          <h1 className="mt-6 font-heading font-bold text-3xl">
            {t.common.donationCancelled}
          </h1>
          <p className="mt-3 text-neutral-600">
            We didn't charge your card. You can try again whenever you're ready — every contribution matters.
          </p>
          <div className="mt-8 flex gap-3 justify-center">
            <Link to="/get-involved" className="gk-btn-primary" data-testid="donate-cancel-retry-btn">
              {t.common.tryAgain}
              <ArrowRight size={16} />
            </Link>
            <Link to="/" className="gk-btn-outline" data-testid="donate-cancel-home-btn">
              <Home size={16} />
              {t.common.backHome}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
